import { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import * as wjcGrid from '@grapecity/wijmo.grid';
import { CellType } from '@grapecity/wijmo.grid';
import './QuoteCopyModal.css';

// 工事種別コード（モック用）
const KOUJI_SYU = {
  KASETSU: '01', // 仮設工事
  DOKOU: '02',   // 土工事
  KAITAI: '03',  // 解体撤去工事
  MON: '04',     // 門周り工事
};

// 金額計算（モック作成用に使用）
const calc = (su, tanka, genkaTanka) => ({
  KINGAKU: Math.round((su ?? 1) * (tanka ?? 0)),
  GENKA_KINGAKU: Math.round((su ?? 1) * (genkaTanka ?? 0)),
});

//モックデータ
export const mockQuoteDetails = {
  2024001: {
    kbns: [
      { QUOTE_KNO: 1, KOUJI_SYU: KOUJI_SYU.KASETSU, KOUJI_DISPLAY_NAME: '仮設工事', TOTAL: 0 },
      { QUOTE_KNO: 2, KOUJI_SYU: KOUJI_SYU.DOKOU,   KOUJI_DISPLAY_NAME: '土工事', TOTAL: 0 },
    ],
    details: [
      //仮設工事
      {
        QUOTE_KNO: 1, QUOTE_MNO: 3,
        KOUJI_SYU: KOUJI_SYU.KASETSU,
        CONTENT: '重機使用料', SIYOU: 'ユニッククレーン 3t',
        SU: 1, TANI: '台',
        GENKA_TANKA: 8000, GENKA_RATE: 0.42, TANKA: 19000,
        KOUJI_TYPE: 2,
        ...calc(1, 19000, 8000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 4,
        KOUJI_SYU: KOUJI_SYU.KASETSU,
        CONTENT: '交通誘導員', SIYOU: '有資格者',
        SU: 1, TANI: '人',
        GENKA_TANKA: 15000, GENKA_RATE: 0.62, TANKA: 24000,
        KOUJI_TYPE: 1,
        ...calc(1, 24000, 15000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 5,
        KOUJI_SYU: KOUJI_SYU.KASETSU,
        CONTENT: '道路使用許可', SIYOU: '',
        SU: 1, TANI: '式',
        GENKA_TANKA: 11300, GENKA_RATE: 0.45, TANKA: 25000,
        KOUJI_TYPE: 1,
        ...calc(1, 25000, 11300),
      },

      //土工事-
      {
        QUOTE_KNO: 2, QUOTE_MNO: 1,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: 'すきとり・整地 重機使用', SIYOU: 't=200㎜',
        SU: 60, TANI: '㎡',
        GENKA_TANKA: 500, GENKA_RATE: 0.50, TANKA: 1000,
        KOUJI_TYPE: 1,
        ...calc(60, 1000, 500),
      },
      {
        QUOTE_KNO: 2, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: '発生残土処理', SIYOU: '場外搬出処分',
        SU: 12, TANI: '㎥',
        GENKA_TANKA: 3000, GENKA_RATE: 0.40, TANKA: 7500,
        KOUJI_TYPE: 2,
        ...calc(12, 7500, 3000),
      },
      {
        QUOTE_KNO: 2, QUOTE_MNO: 3,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: '掘削工 ステコンクリート', SIYOU: '埋め戻し含む',
        SU: 8, TANI: 'ｍ',
        GENKA_TANKA: 1000, GENKA_RATE: 0.50, TANKA: 2000,
        KOUJI_TYPE: 1,
        ...calc(8, 2000, 1000),
      },
    ],
  },
  2024002: {
    kbns: [
      { QUOTE_KNO: 1, KOUJI_SYU: KOUJI_SYU.KAITAI, KOUJI_DISPLAY_NAME: '解体撤去工事', TOTAL: 0 },
      { QUOTE_KNO: 2, KOUJI_SYU: KOUJI_SYU.DOKOU,  KOUJI_DISPLAY_NAME: '土工事', TOTAL: 0 },
    ],
    details: [
      //解体撤去工事
      {
        QUOTE_KNO: 1, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.KAITAI,
        CONTENT: 'カッター工事', SIYOU: '機械使用料含む',
        SU: 25, TANI: 'ｍ',
        GENKA_TANKA: 1000, GENKA_RATE: 0.66, TANKA: 1500,
        KOUJI_TYPE: 2,
        ...calc(25, 1500, 1000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 3,
        KOUJI_SYU: KOUJI_SYU.KAITAI,
        CONTENT: '発生材処分', SIYOU: 'コンクリートガラ処分費',
        SU: 6, TANI: '㎥',
        GENKA_TANKA: 3500, GENKA_RATE: 0.58, TANKA: 6000,
        KOUJI_TYPE: 2,
        ...calc(6, 6000, 3500),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 4,
        KOUJI_SYU: KOUJI_SYU.KAITAI,
        CONTENT: '発生材処分', SIYOU: '混合ゴミ',
        SU: 4, TANI: '㎥',
        GENKA_TANKA: 6000, GENKA_RATE: 0.50, TANKA: 12000,
        KOUJI_TYPE: 2,
        ...calc(4, 12000, 6000),
      },

      //土工事
      {
        QUOTE_KNO: 2, QUOTE_MNO: 1,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: 'すきとり・整地 人力施工', SIYOU: 't=50㎜',
        SU: 40, TANI: '㎡',
        GENKA_TANKA: 450, GENKA_RATE: 0.50, TANKA: 900,
        KOUJI_TYPE: 1,
        ...calc(40, 900, 450),
      },
      {
        QUOTE_KNO: 2, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: '発生残土処理（芝混じり）', SIYOU: '場外搬出処分',
        SU: 5, TANI: '㎥',
        GENKA_TANKA: 6000, GENKA_RATE: 0.46, TANKA: 13000,
        KOUJI_TYPE: 2,
        ...calc(5, 13000, 6000),
      },
      {
        QUOTE_KNO: 2, QUOTE_MNO: 3,
        KOUJI_SYU: KOUJI_SYU.DOKOU,
        CONTENT: '掘削工 基礎コンクリート', SIYOU: '埋め戻し含む',
        SU: 6, TANI: 'ｍ',
        GENKA_TANKA: 2200, GENKA_RATE: 0.48, TANKA: 4500,
        KOUJI_TYPE: 1,
        ...calc(6, 4500, 2200),
      },
    ],
  },

  2024003: {
    kbns: [
      { QUOTE_KNO: 1, KOUJI_SYU: KOUJI_SYU.MON, KOUJI_DISPLAY_NAME: '門周り工事', TOTAL: 0 },
    ],
    details: [
      {
        QUOTE_KNO: 1, QUOTE_MNO: 1,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '機能門柱設置工', SIYOU: '組立設置費',
        SU: 1, TANI: '基',
        GENKA_TANKA: 20000, GENKA_RATE: 0.54, TANKA: 37000,
        KOUJI_TYPE: 1,
        ...calc(1, 37000, 20000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '独立ポスト設置工', SIYOU: '組立・コンクリート根巻含む',
        SU: 1, TANI: '基',
        GENKA_TANKA: 7000, GENKA_RATE: 0.58, TANKA: 12000,
        KOUJI_TYPE: 1,
        ...calc(1, 12000, 7000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 3,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '塗り壁工', SIYOU: '美ブロシルキーHG 材工・トップコート含む',
        SU: 8, TANI: '㎡',
        GENKA_TANKA: 10000, GENKA_RATE: 0.59, TANKA: 16800,
        KOUJI_TYPE: 1,
        ...calc(8, 16800, 10000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 4,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: 'ポスト設置工 材工含む', SIYOU: 'タマヤ 口金タイプ T53 2B12',
        SU: 1, TANI: '基',
        GENKA_TANKA: 26200, GENKA_RATE: 0.66, TANKA: 39600,
        KOUJI_TYPE: 1,
        ...calc(1, 39600, 26200),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 5,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '宅配ボックス', SIYOU: 'Panasonic COMBO ハーフタイプ 前出し・壁付',
        SU: 1, TANI: '基',
        GENKA_TANKA: 44718, GENKA_RATE: 0.58, TANKA: 77100,
        KOUJI_TYPE: 1,
        ...calc(1, 77100, 44718),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 6,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '宅配ボックス 壁付施工費', SIYOU: 'Panasonic COMBO ハーフタイプ',
        SU: 1, TANI: '基',
        GENKA_TANKA: 3000, GENKA_RATE: 0.50, TANKA: 6000,
        KOUJI_TYPE: 1,
        ...calc(1, 6000, 3000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 7,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '表札設置工', SIYOU: 'プレート、連結タイプ',
        SU: 1, TANI: '基',
        GENKA_TANKA: 1800, GENKA_RATE: 0.60, TANKA: 3000,
        KOUJI_TYPE: 1,
        ...calc(1, 3000, 1800),
      },
    ],
  },
  2024004: {
    kbns: [
      { QUOTE_KNO: 1, KOUJI_SYU: KOUJI_SYU.KASETSU, KOUJI_DISPLAY_NAME: '仮設工事', TOTAL: 0 },
      { QUOTE_KNO: 2, KOUJI_SYU: KOUJI_SYU.MON,     KOUJI_DISPLAY_NAME: '門周り工事', TOTAL: 0 },
    ],
    details: [
      //仮設工事
      {
        QUOTE_KNO: 1, QUOTE_MNO: 1,
        KOUJI_SYU: KOUJI_SYU.KASETSU,
        CONTENT: '重機使用料', SIYOU: '高所作業車',
        SU: 1, TANI: '台',
        GENKA_TANKA: 18000, GENKA_RATE: 0.45, TANKA: 40000,
        KOUJI_TYPE: 2,
        ...calc(1, 40000, 18000),
      },
      {
        QUOTE_KNO: 1, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.KASETSU,
        CONTENT: '交通誘導員', SIYOU: '無資格者',
        SU: 1, TANI: '人',
        GENKA_TANKA: 13000, GENKA_RATE: 0.61, TANKA: 21000,
        KOUJI_TYPE: 1,
        ...calc(1, 21000, 13000),
      },

      //門周り工事
      {
        QUOTE_KNO: 2, QUOTE_MNO: 1,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '組立設置費', SIYOU: '片開き門扉',
        SU: 1, TANI: '基',
        GENKA_TANKA: 10000, GENKA_RATE: 0.52, TANKA: 19000,
        KOUJI_TYPE: 1,
        ...calc(1, 19000, 10000),
      },
      {
        QUOTE_KNO: 2, QUOTE_MNO: 2,
        KOUJI_SYU: KOUJI_SYU.MON,
        CONTENT: '下地ブロック積み工', SIYOU: 'スタンダードブロック C-12',
        SU: 6, TANI: '㎡',
        GENKA_TANKA: 10000, GENKA_RATE: 0.50, TANKA: 20000,
        KOUJI_TYPE: 1,
        ...calc(6, 20000, 10000),
      },
    ],
  },
};

// 集計行のマージ処理
class CustomMergeManager extends wjcGrid.MergeManager {
  getMergedRange(panel, r, c, clip = true) {
    var rng = new wjcGrid.CellRange(r, c);
    let dataItem = panel?.grid?.rows[r]?.dataItem;
    if (panel.cellType == CellType.Cell && dataItem && dataItem['Group']) {
      if (c >= 1 && c < 4) {
        rng.col = 1;
        rng.col2 = 3;
        return rng;
      }
      if (c > 4 && c < 7) {
        rng.col = 5;
        rng.col2 = 6;
        return rng;
      }
    }
    return rng;
  }
}

function QuoteDetailModal({ show, setShow, quote, onCopy }) {
  const [viewQuoteDetails, setViewQuoteDetails] = useState([]);
  const [checkedItems, setCheckedItems] = useState(new Set());
  // この見積に存在する工事種別(QUOTE_KNO)一覧（Group対象）
const groupKnos = useMemo(() => {
  if (!quote || !mockQuoteDetails[quote.QUOTE_NO]) return [];
  return mockQuoteDetails[quote.QUOTE_NO].kbns
    .map(k => k.QUOTE_KNO)
    .sort((a, b) => a - b);
}, [quote]);

const allChecked = groupKnos.length > 0 && groupKnos.every(kno => checkedItems.has(kno));
const someChecked = groupKnos.some(kno => checkedItems.has(kno)); // 一部選択（見た目用）

  // Grid初期化処理
  const initializedGrid = (flex) => {
    flex.mergeManager = new CustomMergeManager();
  };

  useEffect(() => {
    if (!quote || !mockQuoteDetails[quote.QUOTE_NO]) {
      setViewQuoteDetails([]);
      return;
    }

    const quoteData = mockQuoteDetails[quote.QUOTE_NO];
    let _viewQuoteDetails = [];
    let _quoteKno = '';

    quoteData.details.forEach((qd, i) => {
      // 明細の小計行を作成
      if (_quoteKno != qd.QUOTE_KNO) {
        const qk = quoteData.kbns.find((x) => x.QUOTE_KNO == qd.QUOTE_KNO);
        _quoteKno = qd.QUOTE_KNO;

        _viewQuoteDetails.push({
          Group: true,
          QUOTE_KNO: qd.QUOTE_KNO,
          CONTENT: String.fromCharCode(64 + qd.QUOTE_KNO) + '. ' + qk.KOUJI_DISPLAY_NAME,
          KINGAKU: qk.TOTAL,
          checked: false,
        });
      }
      // 明細を追加
      _viewQuoteDetails.push(qd);
    });

    setViewQuoteDetails(_viewQuoteDetails);
    setCheckedItems(new Set());
  }, [quote]);

  // チェックボックス変更
  const handleCheckChange = (quoteKno, checked) => {
    const newChecked = new Set(checkedItems);
    if (checked) {
      newChecked.add(quoteKno);
    } else {
      newChecked.delete(quoteKno);
    }
    setCheckedItems(newChecked);
  };

  const handleToggleAll = (checked) => {
  if (checked) {
    setCheckedItems(new Set(groupKnos));
  } else {
    setCheckedItems(new Set());
  }
};

  // 追加ボタン押下
  const handleAdd = () => {
  if (checkedItems.size === 0) {
    alert('工事種別を選択してください');
    return;
  }

  const selectedData = {
    quote: quote,
    kbns: mockQuoteDetails[quote.QUOTE_NO].kbns.filter(k =>
      checkedItems.has(k.QUOTE_KNO)
    ),
    details: mockQuoteDetails[quote.QUOTE_NO].details.filter(d =>
      checkedItems.has(d.QUOTE_KNO)
    ),
  };
  onCopy?.(quote.QUOTE_NO, selectedData);
  setShow(false);
};

  // グリッドのフォーマット処理
  const formatItem = (grid, e) => {
    if (e.panel.cellType == CellType.Cell) {
      var dataItem = grid.rows[e.row].dataItem;
      // 集計行の場合
      if (dataItem && dataItem['Group']) {
        e.cell.style.background = 'rgb(255, 160, 122)';
        e.cell.style.color = 'rgb(255, 255, 255)';
        // チェックボックスを含む行の高さを確保
        grid.rows[e.row].height = 35;
      } else {
        e.cell.style.background = '';
        e.cell.style.color = '';
      }
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={() => setShow(false)} 
      size="xl" 
      centered 
      animation={false}
      backdrop="static"
      enforceFocus={false}
      restoreFocus={false}
    >
      <Modal.Header>
        <div style={{ width: '100%' }}>
          <Modal.Title>見積詳細 - {quote?.KOUJI_MEI}</Modal.Title>
          <div style={{ marginTop: 12 }}>
            <Form>
              <Row>
                <Col md="4" className="pr-1">
                  <Form.Group>
                    <Form.Label>工事名</Form.Label>
                    <Form.Control value={quote?.KOUJI_MEI ?? ''} disabled />
                  </Form.Group>
                </Col>

                <Col md="4" className="pr-1">
                  <Form.Group>
                    <Form.Label>住所</Form.Label>
                    <Form.Control value={quote?.ADDRESS ?? ''} disabled />
                  </Form.Group>
                </Col>

                <Col md="2" className="pr-1">
                  <Form.Group>
                    <Form.Label>顧客名</Form.Label>
                    <Form.Control value={quote?.CLIENT_NAME ?? ''} disabled />
                  </Form.Group>
                </Col>

                <Col md="2" className="pr-1">
                  <Form.Group>
                    <Form.Label>営業担当</Form.Label>
                    <Form.Control value={quote?.TAN_NAME ?? ''} disabled />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="2" className="pr-1">
                  <Form.Group>
                    <Form.Label>金額</Form.Label>
                    <Form.Control
                      value={
                        quote?.MITSU_KIN != null
                          ? `¥${Number(quote.MITSU_KIN).toLocaleString()}`
                          : ''
                      }
                      disabled
                    />
                  </Form.Group>
                </Col>

                <Col md="2" className="pr-1">
                  <Form.Group>
                    <Form.Label>見積日</Form.Label>
                    <Form.Control value={quote?.MITSU_DATE ?? ''} disabled />
                  </Form.Group>
                </Col>

                <Col md="2" className="pr-1">
                  <Form.Group>
                    <Form.Label>見積番号</Form.Label>
                    <Form.Control value={quote?.QUOTE_NO ?? ''} disabled />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <input
            type="checkbox"
            checked={allChecked}
            ref={(el) => {
            if (el) el.indeterminate = !allChecked && someChecked; // 一部選択の見た目
          }}
          onChange={(e) => handleToggleAll(e.target.checked)}
          />
          <span>全選択</span>
          </div>
          <FlexGrid
            itemsSource={viewQuoteDetails}
            selectionMode="None"
            headersVisibility="Column"
            allowSorting={false}
            initialized={initializedGrid}
            formatItem={formatItem}
            isReadOnly={true}
          >
            <FlexGridColumn binding="" header="" width={30} isReadOnly={true}>
              <FlexGridCellTemplate
                cellType="Cell"
                template={(cell) =>
                  cell.item && cell.item['Group'] ? (
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      height: '100%',
                      padding: '5px 0'
                    }}>
                      <input
                      type="checkbox"
                        checked={checkedItems.has(cell.item.QUOTE_KNO)}
                        onChange={(e) => handleCheckChange(cell.item.QUOTE_KNO, e.target.checked)}
                        style={{ width: 14, height: 14, margin: 0 }}
                      />
                    </div>
                  ) : null
                }
              />
            </FlexGridColumn>
            <FlexGridColumn 
              binding="CONTENT" 
              header="名称" 
              width={250}
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="SIYOU" 
              header="仕様" 
              width={200}
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="SU" 
              header="数量" 
              format="n2"
              width={80}
              dataType="Number"
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="TANI" 
              header="単位" 
              width={60}
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="TANKA" 
              header="単価" 
              format="c0"
              width={100}
              dataType="Number"
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="KINGAKU" 
              header="金額" 
              format="c0"
              width={120}
              dataType="Number"
              isReadOnly={true}
            /><FlexGridColumn 
              binding="BIKO" 
              header="備考" 
              width={300}
              isReadOnly={true}
            />
            <FlexGridColumn 
              binding="BIKO_SYANAI" 
              header="社内備考" 
              width={"1*"}
              isReadOnly={true}
            />
          </FlexGrid>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          キャンセル
        </Button>
        <Button 
          variant="primary"
          onClick={handleAdd}
          className="btn-fill footer-button"

        >
          追加
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default QuoteDetailModal;